/**
 * Ticket API - ใช้กับ userApi, sellerApi, riderApi หรือ adminApi ตาม role ที่ล็อกอิน
 * @param {object} api - axios instance (userApi | sellerApi | riderApi | adminApi)
 */

const BASE = "/api/v1/ticket";

export async function listTicketsApi(api, params = {}) {
  const { data } = await api.get(`${BASE}/my`, { params });
  return data;
}

export async function createTicketApi(api, payload) {
  const { data } = await api.post(`${BASE}/create`, payload);
  return data;
}

export async function getTicketByIdApi(api, id) {
  const { data } = await api.get(`${BASE}/${id}`);
  return data;
}

export async function addTicketMessageApi(api, ticketId, payload) {
  const { data } = await api.post(`${BASE}/${ticketId}/messages`, payload);
  return data;
}

export async function closeTicketApi(api, ticketId) {
  const { data } = await api.post(`${BASE}/${ticketId}/close`);
  return data;
}

export async function uploadTicketFilesApi(api, formData) {
  const { data } = await api.post(`${BASE}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
